import { render, staticRenderFns } from "./CurrentCoilStock.vue?vue&type=template&id=01d6edf0&"
import script from "./CurrentCoilStock.vue?vue&type=script&lang=js&"
export * from "./CurrentCoilStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports